const memory = new Map();

function backend() {
  try {
    if (typeof localStorage !== "undefined") return localStorage;
  } catch {
    return null;
  }
  return null;
}

export const storage = {
  get(key) {
    const store = backend();
    if (!store) return memory.get(key) ?? null;
    try {
      return store.getItem(key);
    } catch {
      return memory.get(key) ?? null;
    }
  },

  set(key, value) {
    memory.set(key, value);
    const store = backend();
    if (!store) return;
    try {
      store.setItem(key, value);
    } catch {
      return;
    }
  },

  remove(key) {
    memory.delete(key);
    const store = backend();
    if (!store) return;
    try {
      store.removeItem(key);
    } catch {
      return;
    }
  },

  getJson(key, fallback = null) {
    const raw = storage.get(key);
    if (!raw) return fallback;
    try {
      return JSON.parse(raw);
    } catch {
      return fallback;
    }
  },

  setJson(key, value) {
    storage.set(key, JSON.stringify(value));
  },
};
